import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router";
import styled from "styled-components";
import PrivacyPolicy from "./PrivacyPolicy";
import logo from "./assets/logo.png";

const Container = styled.div`
  min-height: 100vh;
  background-color: #ffffff;
  color: #1e293b;
  font-family: 'Inter', 'Segoe UI', sans-serif;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: bold;
`;

const Main = styled.main`
  padding: 5rem 1.5rem;
  max-width: 64rem;
  margin: 0 auto;
  text-align: center;
`;

const Section = styled.section`
  padding: 4rem 1.5rem;
  background-color: ${(props) => props.bg || "transparent"};
`;

const Footer = styled.footer`
  padding: 4rem 1.5rem;
  background-color: #f9fafb;
  font-size: 0.875rem;
  color: #475569;
`;

const Button = styled.a`
  display: inline-block;
  background-color: #2563eb;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.75rem;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1d4ed8;
  }
`;

function Home() {
  return (
    <Container>
      <Header>
        <Logo>
          <img src={'./logo.png'} alt="LaceAI Logo" style={{ height: "120px" }} />
        </Logo>
        <Link to="#contact">Contact</Link>
      </Header>

      <Main>
        <h1 style={{ fontSize: "2.25rem", fontWeight: "bold", marginBottom: "1rem" }}>
          AI-powered Garmin Workouts from Plain Text
        </h1>
        <p style={{ fontSize: "1.125rem", color: "#64748b", marginBottom: "2rem" }}>
          Type a workout in natural language. LaceAI converts it into a structured Garmin session.
        </p>
        {/* <Button href="#demo">Try a Sample</Button> */}
      </Main>

      <Section bg="#f1f5f9">
        <div style={{ maxWidth: "48rem", margin: "0 auto", textAlign: "left" }}>
          <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "1.5rem" }}>How It Works</h2>
          <ol style={{ paddingLeft: "1.25rem", color: "#475569", lineHeight: "1.75" }}>
            <li>
              Write something like: <code style={{ backgroundColor: "#e2e8f0", padding: "0 0.25rem" }}>15 min warmup, 5x1km @ 4:00/km, 90s jog, cool down</code>
            </li>
            <li>LaceAI parses it into a structured workout.</li>
            <li>We sync it to your Garmin using their Training API.</li>
          </ol>
        </div>
      </Section>

      <Section>
        <div style={{ maxWidth: "48rem", margin: "0 auto", textAlign: "left" }}>
          <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "1.5rem" }}>Features</h2>
          <ul style={{ paddingLeft: "1.25rem", color: "#475569", lineHeight: "1.75" }}>
            <li>Natural language to structured Garmin workout</li>
            <li>Supports intervals, pace, heart rate zones</li>
            <li>Export to Garmin-compatible format</li>
            <li>No manual workout programming needed</li>
          </ul>
        </div>
      </Section>

      <Section bg="#f1f5f9">
        <div style={{ maxWidth: "48rem", margin: "0 auto", textAlign: "left" }}>
          <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "1.5rem" }}>Project Status</h2>
          <p style={{ color: "#475569" }}>
            LaceAI is currently in closed beta. We are ready to integrate with the Garmin Training API and awaiting approval. This project is built for runners by runners.
          </p>
        </div>
      </Section>

      <Footer>
        <div style={{ maxWidth: "48rem", margin: "0 auto", textAlign: "left" }}>
          <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "1rem" }}>Contact</h2>
          <p>
            Reach out: <a href="mailto:alex@laceai.run" style={{ color: "#2563eb" }}>alex@laceai.run</a>
          </p>
          <p style={{ marginTop: "1rem" }}>
            <Link to="/privacy" style={{ color: "#2563eb" }}>Privacy Policy</Link>
          </p>
        </div>
      </Footer>
    </Container>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}
